import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import CardNews from "./cardNews"
import StackGrid from "react-stack-grid"

export default function News() {
  const NEWS = useStaticQuery(graphql`
    query {
      allStrapiUpdates(sort: { fields: Date, order: DESC }) {
       nodes
         {
          Title
          Description
          Date
          Youtube
            Picture {
            publicURL
            size
          }

          url
          Video {
            publicURL
          }
        }
      }
    }
  `)


  const cardColors3 = [
    "rgba(249, 65, 68, 0.8)",
    "rgba(243, 114, 44, 0.8)",
    "rgba(248, 150, 30, 0.8)",
    "rgba(249, 199, 79, 0.8)",
    "rgba(144, 190, 109, 0.8)",
    "rgba(67, 170, 139, 0.8)",
    "rgba(87, 117, 144, 0.8)",
    "rgba(84, 174, 142, 0.8)",
    "rgba(118, 190, 165, 0.8)",
    "rgba(145, 203, 183, 0.8)",
    "rgba(167, 213, 197, 0.8)",
    "rgba(58, 150, 188, 0.8)",
    "rgba(97, 171, 201, 0.8)",
    "rgba(42, 157, 143, 0.8)",
    "rgba(233, 196, 106, 0.8)",
    "rgba(244, 162, 97, 0.8)",
    "rgba(231, 111, 81, 0.8)",
  ]
  const [renderHook, setRenderHook] = useState()
  useEffect(() => {
    setTimeout(() => {
      setRenderHook(null)
    }, 1000)
  }, [])

  return (
    <StackGrid columnWidth={325} gutterWidth={3} gutterHeight={3} duration={0} randomKey={renderHook}>
      <CardNews New={{
        "Title": "Full Publications",
        "url": "https://compassionate-wing-6275f0.netlify.app/publications2",
        "Description": "Visit our near extensive list with the abstract associated.",
        "Picture": { "publicURL": "https://www.med.unc.edu/neuroscience/files/2018/07/9-7-09-polleux-lab-identifies-critical-gene-for-brain-development-and-mental-retardation-2-image2-233x300.jpeg" },
      }}
                colorCard="#ff686b"
                onClick={() => {
                  window.location.href = "publications2"
                }}/>
      {NEWS.allStrapiUpdates.nodes.map((NEW, index) => {
        return (
          <div key={index}>
            <CardNews New={NEW} colorCard={cardColors3[index]}/>
          </div>
        )
      })}

    </StackGrid>
  )
}
